import { PHONE_DISPLAY, PHONE_TEL, ADDRESS } from "@/data/spa";
import { useLang } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  return (
  <footer data-testid="footer" className="border-t border-white/10 bg-[#050706]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-14 flex flex-col md:flex-row md:items-end justify-between gap-10">
      <div>
        <a href="#top" className="flex items-baseline gap-2">
          <span className="font-serif-display text-4xl font-semibold tracking-tight text-[#f0f4f2]">Elite</span>
          <span className="text-[10px] tracking-[0.35em] uppercase text-[#c5a059]">Spa</span>
        </a>
        <p className="mt-4 text-sm text-[#8a9690] font-light max-w-xs leading-relaxed">
          {t.footer.tagline}
        </p>
      </div>
      <div className="text-sm text-[#8a9690] font-light space-y-2 md:text-right">
        <p>{ADDRESS}</p>
        <p>
          <a href={PHONE_TEL} data-testid="footer-phone" className="text-[#c5a059] hover:text-[#dcc286] transition-colors duration-300">
            {PHONE_DISPLAY}
          </a>
        </p>
        <p>{t.footer.hours}</p>
      </div>
    </div>
    <div className="border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row justify-between gap-3 text-[11px] tracking-[0.15em] uppercase text-[#8a9690]/60">
        <span>© {new Date().getFullYear()} Elite SPA. {t.footer.rights}</span>
        <span>{t.footer.promo}</span>
      </div>
    </div>
  </footer>
  );
};
